module.exports = "/_next/static/images/eed077545c030e84666a41a3e8cfcbb8-medium-techcrunch.png.webp";